import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ReactNode, useState } from "react";
import { Box, Divider, IconButton, Menu, MenuItem, Typography } from "..";
import { useTheme } from "../../hooks";
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';

export type ListMenuItem = {
  label: ReactNode;
  action: (selectedIds: number[]) => void;
  disabled?: boolean;
};

export const ListMenu = (props: {
  selectedIds: number[];
  setSelectedIds: (value: React.SetStateAction<number[]>) => void;
  fetchFunction: () => Promise<number[]>;
  listTotal: number | undefined;
  actionMenuItems?: ListMenuItem[];
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <Box>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
        <Box display="flex" alignItems="center">
          {props.selectedIds.length > 0 && (
            <Typography color={theme.palette.success.main} fontSize="0.85rem" fontWeight={"medium"}>
              {props.selectedIds.length}
            </Typography>
          )}
          <ExpandCircleDownIcon sx={{ color: "#08519c" }} />
        </Box>
      </IconButton>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            props.fetchFunction().then((response) => {
              const selectingIds: number[] | undefined = response as unknown as number[] | undefined;
              let _selectedIds: number[] = [...props.selectedIds];

              if (selectingIds) {
                for (let i: number = 0; i < selectingIds.length; i++) {
                  if (!_selectedIds.includes(selectingIds[i])) {
                    _selectedIds.push(selectingIds[i]);
                  }
                }
              }

              props.setSelectedIds(_selectedIds);
            });
            //setAnchorEl(null);
          }}
        >
          + Select All ({props.listTotal})
        </MenuItem>

        <MenuItem
          onClick={() => {
            props.setSelectedIds([]);
            setAnchorEl(null);
          }}
          disabled={props.selectedIds.length === 0}
        >
          - Clear
        </MenuItem>

        <Divider />

        {props.actionMenuItems?.map((actionMenu, index) => (
          <MenuItem
            color="primary"
            key={index}
            onClick={() => {
              actionMenu.action(props.selectedIds);
              setAnchorEl(null);
            }}
            disabled={actionMenu.disabled}
          >
            {actionMenu.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
